import { createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { lazyPage } from '@/lib/lazy-page'
import { contentDocumentsGridContract, normalizeDataGridUrlState } from '@/modules/data-grid'

export type EntityContentSearch = {
  q?: string
  qColumns?: string
  filters?: string
  sort?: string
  columns?: string
}

export function decodeEntityContentSearch(search: Record<string, unknown>): EntityContentSearch {
  return normalizeDataGridUrlState(search, contentDocumentsGridContract)
}

export const EntityContent = lazyPage(() => import('./features/content-list/entity-content.lazy'), 'EntityContent')

export const entityContentRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'content',
  component: EntityContent,
  validateSearch: decodeEntityContentSearch,
  staticData: { title: 'Content' },
})

export const EntityContentEditor = lazyPage(() => import('./features/document/entity-content-editor.lazy'), 'EntityContentEditor')

export const entityContentEditorRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'content/$documentId/edit',
  component: EntityContentEditor,
})

export const EntityContentPreview = lazyPage(() => import('./features/document/entity-content-preview.lazy'), 'EntityContentPreview')

export const entityContentPreviewRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'content/$documentId/preview',
  component: EntityContentPreview,
})

export const EntityDocs = lazyPage(() => import('./features/docs/entity-docs.lazy'), 'EntityDocs')
export const EntityDoc = lazyPage(() => import('./features/docs/entity-docs.lazy'), 'EntityDoc')

export const entityDocsRoute = createRoute({ getParentRoute: () => entityRoute, path: 'docs', component: EntityDocs })
export const entityDocsDocumentRoute = createRoute({ getParentRoute: () => entityRoute, path: 'docs/$slug', component: EntityDoc })

export const EntityContentVersions = lazyPage(() => import('./features/document/entity-content-versions.lazy'), 'EntityContentVersions')

export const entityContentVersionsRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'content/$documentId/versions',
  component: EntityContentVersions,
})
